import { render, staticRenderFns } from "./SolutionsTagList.vue?vue&type=template&id=7796be3c&scoped=true"
import script from "./SolutionsTagList.vue?vue&type=script&lang=js"
export * from "./SolutionsTagList.vue?vue&type=script&lang=js"
import style0 from "./SolutionsTagList.vue?vue&type=style&index=0&id=7796be3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7796be3c",
  null
  
)

export default component.exports